import { useState } from "react";
import { Box, Paper, TextField, Button, Typography } from "@mui/material";

export const ReviewPointsConfig = ({ reviewPoints, setReviewPoints }) => {
    const [newReviewPoints, setNewReviewPoints] = useState(reviewPoints || 0);

    const handleSave = () => {
        setReviewPoints(newReviewPoints);
    };

    return (
        <Paper sx={{ position: "relative", mt: 4, p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Review Points Configuration
            </Typography>
            <Box sx={{ maxWidth: 400 }}>
                <TextField
                    label="Review Points"
                    type="number"
                    fullWidth
                    margin="dense"
                    value={newReviewPoints}
                    onChange={(e) => setNewReviewPoints(parseInt(e.target.value))}
                    helperText="Number of points awarded for reviews"
                    sx={{ mb: 2 }}
                />
                <Button
                    variant="contained"
                    disabled={newReviewPoints === reviewPoints}
                    onClick={handleSave}
                    sx={{ mb: 2 }}
                >
                    Save
                </Button>
            </Box>
        </Paper>
    );
};
